import ImportImageForm from '../components/import-image-form/import-image-form';

ManageIQ.component.addReact('ImportImageForm', ImportImageForm);